import React from 'react'

export default function FloatingCTA() {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)

  React.useEffect(() => {
    // Skjul svævende knapper når mobilmenuen låser body scroll
    const checkOverflow = () => {
      setMobileMenuOpen(document.body.style.overflow === 'hidden')
    }
    const observer = new MutationObserver(checkOverflow)
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'] })
    return () => observer.disconnect()
  }, [])

  if (mobileMenuOpen) return null

  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-5 right-4 sm:bottom-7 sm:right-6 z-30 flex flex-col gap-3 items-end pointer-events-none"
    >
      {/* E-mail knap */}
      <a
        href="mailto:ungesfremtid@outlook.dk"
        aria-label="Send en e-mail til ungesfremtid@outlook.dk"
        title="Send e-mail: ungesfremtid@outlook.dk"
        className="pointer-events-auto group relative w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-[#0c304d] hover:bg-[#16466e] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200 border-2 border-white/90 focus:outline-hidden focus:ring-2 focus:ring-[#0c304d] focus:ring-offset-2"
      >
        <i className="fa-solid fa-envelope text-lg sm:text-xl text-white" aria-hidden="true" />
        {/* Hover label for desktop */}
        <span className="hidden lg:block pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 px-2.5 py-1 text-xs font-semibold text-white bg-neutral-900/90 backdrop-blur-xs rounded-md shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          ungesfremtid@outlook.dk
        </span>
      </a>

      {/* Telefon knap */}
      <a
        href="tel:25778646"
        aria-label="Ring til Unges Fremtid på 25 77 86 46"
        title="Ring: 25 77 86 46"
        className="pointer-events-auto group relative w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-[#f39223] hover:bg-[#e08112] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200 border-2 border-white/90 focus:outline-hidden focus:ring-2 focus:ring-[#f39223] focus:ring-offset-2"
      >
        <i className="fa-solid fa-phone text-lg sm:text-xl text-white" aria-hidden="true" />
        {/* Hover label for desktop */}
        <span className="hidden lg:block pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 px-2.5 py-1 text-xs font-semibold text-white bg-neutral-900/90 backdrop-blur-xs rounded-md shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Ring: 25 77 86 46
        </span>
      </a>
    </aside>
  )
}
